import { format } from "date-fns";
import type { ManagerReportResponse } from "@/types/reports";

export type SummaryMetric = {
  id: string;
  label: string;
  value: string;
  subLabel?: string;
  accent?: "default" | "attention";
};

export const numberFormatter = new Intl.NumberFormat("en-GB");

export const hoursFormatter = new Intl.NumberFormat("en-GB", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatDateLabel(date?: Date): string {
  if (!date) return "All time";
  return format(date, "PP");
}

type CreateSummaryMetricsOptions = {
  report?: ManagerReportResponse | null;
  startDate?: Date;
  endDate?: Date;
};

export function createSummaryMetrics({
  report,
}: CreateSummaryMetricsOptions): SummaryMetric[] {
  if (!report) {
    return [
      {
        id: "total-signins",
        label: "Total Sign-ins",
        value: "—",
      },
      {
        id: "unique-workers",
        label: "Unique Workers",
        value: "—",
      },
      {
        id: "total-hours",
        label: "Hours Logged",
        value: "—",
      },
      {
        id: "flagged",
        label: "Flagged Records",
        value: "—",
      },
    ];
  }

  const { summary } = report;

  return [
    {
      id: "total-signins",
      label: "Total Sign-ins",
      value: numberFormatter.format(summary.totalSignIns),
      subLabel: "Workers",
    },
    {
      id: "unique-workers",
      label: "# of Workers",
      value: numberFormatter.format(summary.uniqueWorkers),
    },
    {
      id: "total-hours",
      label: "Hrs Logged",
      value: `${hoursFormatter.format(summary.totalHoursWorked)} h`,
      subLabel: `Avg shift — ${hoursFormatter.format(summary.averageShiftHours)}h`,
    },
    {
      id: "flagged",
      label: "Flagged",
      value: numberFormatter.format(summary.flaggedSignIns),
      subLabel: summary.flaggedSignIns > 0 ? "Needs review" : "No issues",
      accent: summary.flaggedSignIns > 0 ? "attention" : "default",
    },
  ];
}
